import PostsUserPage from 'flarum/forum/components/PostsUserPage';
/**
 * The `LikesUserPage` component shows posts which user the user liked.
 */
export default class LikesUserPage extends PostsUserPage {
  params(user) {
    return {
      filter: {
        type: 'comment',
        likedBy: user.id()
      }
    };
  }
}
flarum.reg.add('flarum-likes', 'forum/components/LikesUserPage', LikesUserPage);